import { Controller } from "@hotwired/stimulus"
import { toast } from "../lib/toast"

// Handles inline annotation changes (age/gender/country) with toast feedback
export default class extends Controller {
  static values = {
    url: String,
    ageUrl: String,
  }

  connect() {
    this.csrfToken = document.querySelector('meta[name="csrf-token"]').content
  }

  update(event) {
    const select = event.target
    const row = select.closest('tr')
    if (!row) return
    const instagramUserId = row.dataset.userId
    const field = select.dataset.field
    const value = select.value

    if (!instagramUserId || !field) return

    this.submit(row, { [field]: value })
      .then((json) => {
        if (json && json.msg === 'success') {
          this.highlight(row, 'success')
          toast('保存しました', 'success')
        } else {
          throw new Error('failed')
        }
      })
      .catch(() => {
        this.highlight(row, 'error')
        toast('保存に失敗しました', 'error')
      })
  }

  predictAge(event) {
    if (!this.hasAgeUrlValue) return

    const button = event.currentTarget
    const row = button.closest('tr')
    if (!row) return

    const instagramUserId = row.dataset.userId
    if (!instagramUserId) return

    const originalHtml = button.innerHTML
    button.disabled = true
    button.innerHTML = '<span class="loading loading-spinner loading-xs"></span>'

    this.requestAge(instagramUserId)
      .then((age) => {
        const ageSelect = row.querySelector('select[data-field="age"]')
        if (ageSelect) {
          ageSelect.value = age
        }
        return this.submit(row, { age })
          .then((json) => {
            if (json && json.msg === 'success') {
              this.highlight(row, 'success')
              toast('AI判定の結果を保存しました', 'success')
            } else {
              throw new Error('failed')
            }
          })
      })
      .catch(() => {
        this.highlight(row, 'error')
        toast('AI判定に失敗しました', 'error')
      })
      .finally(() => {
        button.disabled = false
        button.innerHTML = originalHtml
      })
  }

  highlight(row, kind) {
    const cls = kind === 'success' ? 'bg-success/10' : 'bg-error/10'
    row.classList.add(cls)
    setTimeout(() => row.classList.remove(cls), 1200)
  }

  submit(row, attributes) {
    const instagramUserId = row.dataset.userId
    if (!instagramUserId) return Promise.reject(new Error('missing user id'))

    return fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken,
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        instagram_user: {
          id: instagramUserId,
          instagram_user_attribute_attributes: attributes,
        },
      }),
    }).then((response) => {
      if (!response.ok) throw new Error('request failed')
      return response.json()
    })
  }

  requestAge(instagramUserId) {
    return fetch(this.ageUrlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken,
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        instagram_user: {
          id: instagramUserId,
        },
      }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('request failed')
        return response.json()
      })
      .then((json) => {
        const result = json?.result
        if (result === undefined || result === null || result === 'error') {
          throw new Error('invalid result')
        }
        return result.toString()
      })
  }
}
